<template>
  <div class="question-box2">
    <div class="question-text">{{ title1 }}</div>
    <div class="question-answer">
      <div :class="'question-item '+node.checked" @click="isClick1&&selected(1,index)" v-for="(node,index) in newItem1" :key="index">
        <div class="answer" v-html="node.answer"></div>
        <span class="show_icon_true"></span>
        <span class="show_icon_false"></span>
      </div>
    </div>
    <div v-if="showItem2||nshowItem2" class="question-text qt-2">{{ title2 }}</div>
    <div class="question-answer">
      <div v-if="showItem2||nshowItem2" :class="'question-item '+node2.checked" @click="isClick2&&selected(2,i)" v-for="(node2,i) in newItem2" :key="node2.option">
        <div class="answer" v-html="node2.answer"></div>
        <span class="show_icon_true"></span>
        <span class="show_icon_false"></span>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
export default {
  name: "QuestionBox2",
  props:{
    title1: {
      type:String,
      default:"",
    },
    items1:{
      type:Array,
      default:()=>{
        return [];
      }
    },
    index1:{
      type:String,
      default:null
    },
    title2: {
      type:String,
      default:"",
    },
    items2:{
      type:Array,
      default:()=>{
        return [];
      }
    },
    index2:{
      type:String,
      default:null
    },
    showItem2: {
      type:Boolean,
      default:false
    }
  },
  data(){
    return {
      newItem1:[],
      newItem2:[],
      isClick1:false,
      isClick2:false,
      nshowItem2: false
    };
  },
  computed:{
    ...mapState(['is_click'])
  },
  mounted() {
    //将正确答案和全部答案列表通过vuex存储起来
    this.$store.commit('set_true_answer',this.index1);
    this.$store.commit('set_question_list',this.newItem1);

    this.isClick1 = true;
    this.$store.commit('set_is_click',true);
  },
  methods:{
    selected:function(type,index){

      if(this.is_click){
        if(type == 1) {
          this.newItem1.forEach(function(item){
            item.checked = '';
          });
          this.newItem1[index].checked = 'active';
          if(this.newItem1[index].option == 'A') {
            this.nshowItem2 = true;
            this.$store.commit('set_true_answer',this.index2);
            this.$store.commit('set_question_list',this.newItem2);

            this.isClick2 = true;
          }else {
            this.$emit('selected', this.newItem1[index].option)
          }
        }else {
          this.newItem2.forEach(function(item){
            item.checked = '';
          });
          this.newItem2[index].checked = 'active';
          this.$emit('selected', this.newItem2[index].option);
        }

      }else{
        return this.isClick1=false
      }
    }
  },

  watch:{
    "items1":{
      handler (newVal) {
        this.newItem1 = newVal;
        let newItems = new Array();
        for(let i=0;i<this.newItem1.length;i++){
          let keycode = i+65;
          let option = String.fromCharCode(keycode);
          newItems.push({
            option:option,
            answer:this.newItem1[i],
            checked:'',
            index:i
          });
        }
        this.newItem1 = newItems;
      },
      deep: true,
      immediate: true
    },
    "items2":{
      handler (newVal) {
        this.newItem2 = newVal;
        let newItems = new Array();
        for(let i=0;i<this.newItem2.length;i++){
          let keycode = i+65;
          let option = String.fromCharCode(keycode);
          newItems.push({
            option:option,
            answer:this.newItem2[i],
            checked:'',
            index:i
          });
        }
        this.newItem2 = newItems;
      },
      deep: true,
      immediate: true
    },
    "showItem2":{
      handler (newVal) {
        this.isClick1 = false;
        this.$store.commit('set_true_answer',this.index2);
        this.$store.commit('set_question_list',this.newItem2);

        this.isClick2 = true;
      },
      deep: true,
      immediate: true
    }
  },
}
</script>

<style scoped>

</style>
